// extracted by mini-css-extract-plugin
module.exports = {"content":"index-module--content--3q0HM"};